// web/src/pages/Landing.tsx
import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-800 to-pink-700 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-2xl p-12 max-w-md w-full text-center">
        <img src="/BolsaFish.png" alt="Bolsa Fish" className="bf-logo-ring mx-auto mb-5 h-24 w-24 rounded-full object-contain p-2" />
        <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
          Bolsa Fish
        </h1>

        <p className="text-lg mb-8 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent font-medium">
          Welcome to the Admin & Manager Portal
        </p>

        <Link
          to="/admin"
          className="bf-glossy-btn inline-block w-full py-3 text-white text-xl font-semibold rounded-xl transition transform hover:scale-105"
        >
          Get Started
        </Link>
      </div>
    </div>
  );
}
